import React from "react";
import { useEffect, useState, useRef, useCallback, useMemo } from "react";
import { Col, Row } from "reactstrap";
import { useMediaQuery } from "react-responsive";
import { APILA } from "../../../../../config/apila";
import { APIMS } from "../../../../../config/apims";
import { faRectangleList, faMagnifyingGlass, faFilter } from '@fortawesome/free-solid-svg-icons';
import "bulma/css/bulma.css";
import "../../../../../index.css";
import swal from "sweetalert";
import { useLocation, useNavigate, Link } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import ToastError from "../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../NotificationToast/ToastSuccess";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ClipLoader, PulseLoader} from "react-spinners";
import ModalLeger from './modal/legerTeacher';

/* ===========================
   🔥 SKELETON SHIMMER STYLE
=========================== */
const shimmerStyle = `
  @keyframes shimmer {
    0% { background-position: -468px 0; }
    100% { background-position: 468px 0; }
  }
  .shimmer {
    animation-duration: 1.2s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-name: shimmer;
    background: #f6f7f8;
    background: linear-gradient(
      to right,
      #ddeaffff 8%,
      #f4f8ffff 18%,
      #ddeaffff 33%
    );
    background-size: 800px 104px;
  }
  .shimmer-select {
    height: 35px;
    border-radius: 4px;
  }
  .shimmer-row {
    height: 38px;
  }


  // .at-search{ min-width: 280px; }
  // .at-input{
  //   width:100%;
  //   height: 38px;
  //   border:1px solid #280095;
  //   border-radius: 10px;
  //   padding: 0 12px;
  //   font-size: 13px;
  //   outline:none;
  // }
  // .at-input:focus, .at-select:focus{
  //   border-color:#94a3b8;
  //   box-shadow: 0 0 0 3px rgba(148,163,184,0.25);
  // }
    
  `;



export default function Dimensi() {
  document.title = "Leger";

  const [savingId, setSavingId] = useState(null);

  const [page] = useState(1);
  const [limit] = useState(1000);
  const [ascending] = useState(1);
  const [descending] = useState(0);
  const [keyword] = useState("");
  const token = localStorage.getItem("token");

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 780px)" });
  const [loading, setLoading] = useState(false);
  const firstLoadDone = useRef(false);

  const storageBranchGroping = localStorage.getItem("ysb_branch_id");
  const storageLevel = localStorage.getItem("level");
  const storageSchoolId = localStorage.getItem('ysb_school_id');
  const storageTeacher = localStorage.getItem('teacherID');
  const storageBranch = localStorage.getItem('ysb_branch_id');
  
  // Data master
  const [getDataDimensi, setGetDataDimensi] = useState([]);
  const [loadingDimensi, setLoadingDimensi] = useState(true);
  const [getDataSemesterMap, setGetDataSemesterMap] = useState([]);

  // Table data
  const [getData, setGetData] = useState([]);

  // UI state
  const [hasSearched, setHasSearched] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [isFilterDirty, setIsFilterDirty] = useState(false);
  const [selectedTab, setSelectedTab] = useState(null);
  const [isFetching, setIsFetching] = useState(false);

  // Search per tab/element (client-side)
  const [searchMap, setSearchMap] = useState({});

  const [namaTA, setNamaTA] = useState("");
  const [namaSmstr, setNamaSmstr] = useState("");

  // Filter form
  const [form2, setForm2] = useState({
    ysb_semester_id: "",
    ysb_dimensi_id: "",
    ysb_branch_id: "",
    ysb_school_id: "",
    ysb_teacher_id: "",
  });

  // EDIT nilai
  const [form3, setForm3] = useState({
    ysb_element_recap_id_id: "",
    ysb_sub_element_value: "",
  });

  const [updateId, setUpdateID] = useState(null);
  const id_user = localStorage.getItem("id_admin") || "";
  const output_id_user = id_user.replace(/[|&;$%@"<>()+,]/g, "");

  // Permission
  const location = useLocation();
  const [permission, setPermission] = useState({
    create: 0,
    read: 0,
    update: 0,
    delete: 0,
  });
  const navigate = useNavigate();

  useEffect(() => {
    const level = localStorage.getItem("level");
    const storageItems = JSON.parse(localStorage.getItem("role_permission")) || [];
    if (level === "developer" || level === "superadmin") {
      setPermission({ create: 1, read: 1, update: 1, delete: 1 });
      return;
    }
    const foundPermission = storageItems.find((item) => item.menu?.url === location.pathname);
    if (!foundPermission) navigate("/dashboard");
    else {
      setPermission({
        create: foundPermission.create,
        read: foundPermission.read,
        update: foundPermission.update,
        delete: foundPermission.delete,
      });
    }
  }, [location.pathname, navigate]);

  /* API HEADERS */
  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }),
    [token]
  );

  // ---------- helper refs ----------
  const isMounted = useRef(true);
  const abortControllers = useRef([]);

  useEffect(() => {
    return () => {
      isMounted.current = false;
      abortControllers.current.forEach((c) => c.abort());
    };
  }, []);

  const safeStr = (v) => (v === null || v === undefined ? "" : String(v));

  // =========================
  // INIT: Semester
  // =========================
  const fetchInit = useCallback(async () => {
    setLoading(true);
    const controller = new AbortController();
    abortControllers.current.push(controller);

    try {
      const semesterRes = await APIMS.get(
        `/api/access/semesters?page=${page}&limit=${limit}&ascending=${descending}&search=${keyword}`,
        { ...fetchParams, signal: controller.signal }
      );
      if (!isMounted.current || controller.signal.aborted) return;

      if (semesterRes?.status === 200) {
        const semesters = semesterRes?.data?.data || [];
        const active = semesters.find((semester) => Number(semester?.status) === 1) || semesters[0];
        setGetDataSemesterMap(semesters);
        if (active) {
          setNamaTA(active.name_year || "");
          setNamaSmstr(active.semester || "");
          setForm2((prev) => ({ ...prev, ysb_semester_id: active.id }));
        } else {
          setLoadingDimensi(false);
        }
      }
    } catch (err) {
      if (err?.name === "CanceledError" || err?.name === "AbortError") return;
      setLoadingDimensi(false);
      swal({
        title: "Failed",
        text: err?.response?.data?.message || err.message || "Error",
        icon: "error",
      });
    } finally {
      if (isMounted.current) setLoading(false);
    }
  }, [descending, fetchParams, keyword, limit, page]);

  useEffect(() => {
    fetchInit();
  }, [fetchInit]);

  // Dimensi mengikuti semester pilihan dan identitas guru yang login.
  const selectedSemester = useMemo(
    () => getDataSemesterMap.find((semester) =>
      String(semester?.id) === String(form2.ysb_semester_id)
    ) || null,
    [getDataSemesterMap, form2.ysb_semester_id]
  );

  useEffect(() => {
    if (!form2.ysb_semester_id) return;

    const controller = new AbortController();
    let cancelled = false;
    const fetchDimensi = async () => {
      setLoadingDimensi(true);
      setGetDataDimensi([]);
      setForm2((prev) => ({ ...prev, ysb_dimensi_id: "" }));

      const academicYearId =
        selectedSemester?.ysb_academic_year_id ??
        selectedSemester?.academic_year_id ??
        selectedSemester?.ysb_academic_year?.id ?? "";

      try {
        const response = await APILA.get("/api/access/dimensis", {
          ...fetchParams,
          signal: controller.signal,
          params: {
            page: 1,
            limit: 10,
            ascending: 1,
            search: "",
            branch: "",
            level: storageLevel || "",
            ysb_academic_year_id: academicYearId,
            ysb_semester_id: form2.ysb_semester_id,
            ysb_branch_id: storageBranch || "",
            ysb_school_id: storageSchoolId || "",
            ysb_grade_level_id: "",
            ysb_teacher_id: storageTeacher || "",
          },
        });
        if (cancelled || !isMounted.current) return;
        const dims = (Array.isArray(response?.data?.data) ? response.data.data : [])
          .filter((d) => d?.status === undefined || Number(d.status) === 1);
        setGetDataDimensi(dims);
        setForm2((prev) => ({ ...prev, ysb_dimensi_id: dims[0]?.id || "" }));
      } catch (err) {
        if (cancelled || controller.signal.aborted) return;
        console.error("Gagal mengambil data dimensi:", err);
        setGetDataDimensi([]);
        setForm2((prev) => ({ ...prev, ysb_dimensi_id: "" }));
      } finally {
        if (!cancelled && isMounted.current) setLoadingDimensi(false);
      }
    };

    fetchDimensi();
    return () => {
      cancelled = true;
      controller.abort();
    };
  }, [form2.ysb_semester_id, selectedSemester, fetchParams, storageLevel, storageBranch, storageSchoolId, storageTeacher]);

  // =========================
  // Filter complete
  // =========================
  const isFilterComplete =
    isFilterDirty &&
    !!form2.ysb_semester_id &&
    !!form2.ysb_dimensi_id;

  // =========================
  // Fetch table data
  // =========================
  const GetResponseData = useCallback(async () => {
  if (
    !form2.ysb_semester_id ||
    !form2.ysb_dimensi_id
  ) return;

  const params = {

     ysb_semester_id: form2?.ysb_semester_id,
          level: storageLevel,
          branch: storageBranch,
          ysb_dimensi_id: form2?.ysb_dimensi_id,
          ysb_school_id: storageSchoolId,
          ysb_teacher_id: storageTeacher
  };

  try {
    const response = await APILA.get(
      "/api/leger-teacher/teacher",
      {
        params,
        ...fetchParams,
      }
    );

    if (response?.status === 200) {
      setGetData(response.data.data || []);
    }
  } catch (error) {
    swal({
      title: "Gagal",
      text: error?.response?.data?.message || "Gagal mengambil data",
      icon: "error",
    });
  }
}, [form2, fetchParams, storageLevel]);

  // =========================
  // CLIENT-SIDE SEARCH (per element/tab)
  // =========================
  // const filteredRekapanMap = useMemo(() => {
  //   const elements = getData?.[0]?.data_element || [];
  //   const out = {};

  //   const sortByNameAsc = (arr) =>
  //     [...(arr || [])].sort((a, b) => {
  //       const an = (a?.name_student || "").toString().toLowerCase();
  //       const bn = (b?.name_student || "").toString().toLowerCase();
  //       return an.localeCompare(bn, "id", { sensitivity: "base" });
  //     });

  //   elements.forEach((el) => {
  //     const qRaw = (searchMap?.[el?.id] || "").toString().trim().toLowerCase();
  //     const rows = el?.rekapan || [];

  //     if (!qRaw) {
  //       out[el?.id] = sortByNameAsc(rows);
  //       return;
  //     }

  //     const filtered = rows.filter((r) => {
  //       const name = (r?.name_student || "").toString().toLowerCase();
  //       const nisn = (r?.nisn ?? "").toString().toLowerCase();
  //       return name.includes(qRaw) || nisn.includes(qRaw);
  //     });

  //     out[el?.id] = sortByNameAsc(filtered);
  //   });

  //   return out;
  // }, [getData, searchMap]);


  const filteredRekapanMap = useMemo(() => {
  const elements = getData?.[0]?.data_element || [];
  const out = {};

  const sortByNameAsc = (arr) =>
    [...(arr || [])].sort((a, b) => {
      const orderA =
        a?.order_absen === null ||
        a?.order_absen === undefined ||
        a?.order_absen === ""
          ? null
          : Number(a.order_absen);

      const orderB =
        b?.order_absen === null ||
        b?.order_absen === undefined ||
        b?.order_absen === ""
          ? null
          : Number(b.order_absen);

      const aIsNew = orderA !== null && !Number.isNaN(orderA);
      const bIsNew = orderB !== null && !Number.isNaN(orderB);

      if (!aIsNew && bIsNew) return -1;
      if (aIsNew && !bIsNew) return 1;

      if (aIsNew && bIsNew) {
        if (orderA !== orderB) return orderA - orderB;

        const an = (a?.name_student || "").toString().trim();
        const bn = (b?.name_student || "").toString().trim();

        const cmpName = an.localeCompare(bn, "id", {
          sensitivity: "base",
          numeric: true,
        });

        if (cmpName !== 0) return cmpName;

        const aNisn = (a?.nisn || "").toString();
        const bNisn = (b?.nisn || "").toString();

        return aNisn.localeCompare(bNisn, "id", {
          numeric: true,
          sensitivity: "base",
        });
      }

      const an = (a?.name_student || "").toString().trim();
      const bn = (b?.name_student || "").toString().trim();

      const cmpName = an.localeCompare(bn, "id", {
        sensitivity: "base",
        numeric: true,
      });

      if (cmpName !== 0) return cmpName;

      const aNisn = (a?.nisn || "").toString();
      const bNisn = (b?.nisn || "").toString();

      return aNisn.localeCompare(bNisn, "id", {
        numeric: true,
        sensitivity: "base",
      });
    });

  elements.forEach((el) => {
    const qRaw = (searchMap?.[el?.id] || "").toString().trim().toLowerCase();
    const rows = el?.rekapan || [];

    if (!qRaw) {
      out[el?.id] = sortByNameAsc(rows);
      return;
    }

    const filtered = rows.filter((r) => {
      const name = (r?.name_student || "").toString().toLowerCase();
      const nisn = (r?.nisn ?? "").toString().toLowerCase();
      return name.includes(qRaw) || nisn.includes(qRaw);
    });

    out[el?.id] = sortByNameAsc(filtered);
  });

  return out;
}, [getData, searchMap]);



  // AUTO SELECT TAB
  useEffect(() => {
    if (getData.length > 0 && getData[0]?.data_element?.length > 0 && !selectedTab) {
      setSelectedTab(getData[0].data_element[0].name_element);
    }
  }, [getData, selectedTab]);

  // FIRST LOAD: tampilkan table otomatis setelah default filter lengkap
  useEffect(() => {
    if (
      firstLoadDone.current ||
      !form2.ysb_semester_id ||
      !form2.ysb_dimensi_id
    ) return;
  
    firstLoadDone.current = true;
  
    (async () => {
      setIsFetching(true);
      await GetResponseData(); // ✅ HANYA SEKALI
      setHasSearched(true);
      setIsFirstLoad(false);
      setIsFilterDirty(false);
      setIsFetching(false);
    })();
  
  }, [
    form2.ysb_semester_id,
    form2.ysb_dimensi_id
  ]);

  // Reset tab kalau filter berubah
  useEffect(() => {
    setSelectedTab(null);
  }, [
    form2.ysb_semester_id,
    form2.ysb_dimensi_id
  ]);

  // =========================
  // HANDLER perubahan filter (select HTML)
  // =========================
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "ysb_semester_id") setLoadingDimensi(true);
    setForm2((prev) => ({ ...prev, [name]: value }));

    if (!isFirstLoad) {
      setIsFilterDirty(true);
      setHasSearched(false);
    }
  };


  // =========================
  // BUTTON CARI
  // =========================
  const handleCari = async () => {
    // validasi (biar user jelas)
    if (!form2.ysb_semester_id || !form2.ysb_dimensi_id || loadingDimensi) {
      swal({
        title: "Filter belum lengkap",
        text: "Pastikan Semester dan Dimensi sudah dipilih.",
        icon: "warning",
      });
      return;
    }

    setSelectedTab(null);
    setGetData([]);
    setSearchMap({});
    setHasSearched(false);
    setIsFetching(true);

    try {
      await GetResponseData();
      setHasSearched(true);
      setIsFilterDirty(false);
    } catch (err) {
      swal({
        title: "Failed",
        text: err?.response?.data?.message || "Terjadi kesalahan",
        icon: "error",
      });
    } finally {
      setIsFetching(false);
    }
  };

  const [showModal, setShowModal] = useState(false);
  const [dataModal, setDataModal] = useState(null);

  const handleOpenModal = (element, rekap) => {
    setDataModal({
        name_element: element?.name_element,
        description: element?.description,
        kkca_description: rekap?.kkca_description,
        name_student: rekap?.name_student,
        nisn: rekap?.nisn,

        // ⬇️ metadata utk simpan input capaian (kolom Karyawan / Adab)
        ysb_dimensi_id: element?.ysb_dimensi_id,
        ysb_element_id: element?.id,
        ysb_semester_id: rekap?.ysb_semester_id,
        ysb_school_id: rekap?.ysb_school_id,
        ysb_branch_id: rekap?.ysb_branch_id,

        // ✅ ini solusi teacher_id untuk Pengawas Adab
        ysb_teacher_id: rekap?.ysb_teacher_id,

        ysb_student_id: rekap?.ysb_student_id,
        ysb_kelas_id: rekap?.ysb_kelas_id,
        ysb_element_recap_id: rekap?.ysb_element_recap_id,

        sub_elements: rekap?.sub_elements || [],
    });
    setShowModal(true);
  };

  const handleModalSaved = useCallback((payload) => {
      if (!payload) return;
  
      const recapId = payload?.ysb_element_recap_id;
      if (!recapId) return;
  
      // update dataModal supaya saat buka modal lagi sudah membawa data terbaru
      setDataModal((prev) => {
        if (!prev) return prev;
        if (prev?.ysb_element_recap_id !== recapId) return prev;
        return {
          ...prev,
          sub_elements: payload?.sub_elements ?? prev.sub_elements,
          average: payload?.average ?? prev.average,
          kkca_description: payload?.kkca_description ?? prev.kkca_description,
          kkca_description_full: payload?.kkca_description_full ?? prev.kkca_description_full,
        };
      });
  
      // update table data tanpa mengurangi fitur lain
      setGetData((prev) => {
        const root = Array.isArray(prev) ? prev : [];
        if (!root.length) return prev;
  
        return root.map((group) => {
          const dataEl = Array.isArray(group?.data_element) ? group.data_element : [];
          const nextDataEl = dataEl.map((el) => {
            const rekapan = Array.isArray(el?.rekapan) ? el.rekapan : [];
            const nextRekapan = rekapan.map((r) => {
              if (r?.ysb_element_recap_id !== recapId) return r;
              return {
                ...r,
                average: payload?.average ?? r.average,
                kkca_description: payload?.kkca_description ?? r.kkca_description,
                kkca_description_full: payload?.kkca_description_full ?? r.kkca_description_full,
                sub_elements: payload?.sub_elements ?? r.sub_elements,
              };
            });
            return { ...el, rekapan: nextRekapan };
          });
  
          return { ...group, data_element: nextDataEl };
        });
      });
    }, []);

  const toTitleCase = (value) => {
    const s = safeStr(value).toLowerCase().trim();
    if (!s) return "";
    return s.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.slice(1));
  };

   return (
    <>
      <style>{shimmerStyle}</style>

      <div className="body leger-page">
        <div className="page-header-card">
          <div className="page-header-top d-flex">
            <div className="page-title-wrap">
              <span className="page-title-icon">
                <FontAwesomeIcon icon={faRectangleList} />
              </span>
              <h4 className="page-title-text">Leger</h4>
            </div>
          </div>

          <nav aria-label="breadcrumb" className="custom-breadcrumb-nav mt-4">
            <ol className="custom-breadcrumb">
              <li className="custom-breadcrumb-item">
                <Link to="/dashboards-teacher">Dashboard</Link>
              </li>
              <li className="custom-breadcrumb-separator">/</li>
              <li className="custom-breadcrumb-item active" aria-current="page">
                Leger
              </li>
            </ol>
          </nav>
        </div>

        <div className="body-content leger-content mt-2">
          <section className="leger-filter-card">
            <div className="leger-filter-header">
              {/* <div className="leger-filter-title-wrap">
                <span className="leger-filter-icon">
                  <FontAwesomeIcon icon={faFilter} />
                </span>
                <div>
                  <h3 className="leger-filter-title">Filter Leger</h3>
                  <p className="leger-filter-subtitle">
                    Pilih semester dan dimensi penilaian.
                  </p>
                </div>
              </div> */}
            </div>

            {loading ? (
              <div className="leger-filter-grid leger-filter-grid-teacher">
                {Array.from({ length: 2 }).map((_, index) => (
                  <div className="leger-filter-field" key={`leger-teacher-shimmer-${index}`}>
                    
                    <div className="shimmer leger-filter-shimmer-control" />
                  </div>
                ))}
                <div className="leger-filter-field leger-filter-action">
                  <div className="shimmer leger-filter-shimmer-control" />
                </div>
              </div>
            ) : (
              <div className="leger-filter-grid leger-filter-grid-teacher">
                <div className="leger-filter-field">
                  <label className="leger-filter-label">Semester</label>
                  <select
                    className="leger-filter-select"
                    name="ysb_semester_id"
                    value={form2.ysb_semester_id}
                    onChange={handleChange}
                  >
                    <option value="" hidden>
                      {namaTA} (Semester {namaSmstr})
                    </option>
                    {getDataSemesterMap.map((user, index) => (
                      <option key={index} value={user?.id}>
                        {/* {user?.name_year} (Semester {user?.semester}) */}
                         {user?.name_year} (Semester {user?.semester}){Number(user?.status) === 1 ? " • Aktif" : ""}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="leger-filter-field">
                  <label className="leger-filter-label">Dimensi</label>
                  <select
                    className="leger-filter-select"
                    name="ysb_dimensi_id"
                    value={form2.ysb_dimensi_id}
                    onChange={handleChange}
                    disabled={loadingDimensi || getDataDimensi.length === 0}
                  >
                    <option value="" hidden>
                      {loadingDimensi ? "Memuat dimensi..." : getDataDimensi.length === 0 ? "Belum ada dimensi" : "Pilih Dimensi"}
                    </option>
                    {getDataDimensi.map((user, index) => (
                      <option key={index} value={user?.id}>
                        {user?.name_dimensi}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="leger-filter-field leger-filter-action">
                  <button
                    type="button"
                    onClick={handleCari}
                    disabled={!isFilterComplete}
                    className="btn leger-filter-button"
                  >
                    Cari
                  </button>
                </div>
              </div>
            )}
          </section>

          {isFetching && (
            <div className="leger-loading">
              <PulseLoader color="#3f5bea" size={12} />
            </div>
          )}

          {hasSearched && !isFetching && (
            <Tabs
              id="leger-tabs-teacher"
              activeKey={selectedTab}
              onSelect={(k) => setSelectedTab(k)}
              className="leger-tabs"
            >
              {(getData?.[0]?.data_element || []).map((element, eIdx) => {
                const rows = filteredRekapanMap[element?.id] || [];

                return (
                  <Tab
                    key={element?.id || eIdx}
                    eventKey={element?.name_element}
                    title={element?.name_element}
                  >
                    <div className="leger-element-description">
                      <h5>{element?.description}</h5>
                    </div>

                    <div className="leger-search-wrap">
                      <FontAwesomeIcon icon={faMagnifyingGlass} className="leger-search-icon" />
                      <input
                        className="leger-search-input"
                        placeholder="Cari Siswa / NISN"
                        value={searchMap[element?.id] || ""}
                        onChange={(e) =>
                          setSearchMap((prev) => ({
                            ...prev,
                            [element?.id]: e.target.value,
                          }))
                        }
                      />
                    </div>

                    <div className="leger-table-card">
                      <div className="leger-table-scroll">
                        <table className="leger-table">
                          <thead>
                            <tr>
                              <th className="leger-col-number">No</th>
                              <th className="leger-col-name">Nama</th>
                              <th className="leger-col-nisn">NISN</th>
                              <th className="leger-col-score">Nilai</th>
                              <th className="leger-col-kkca">KKCA</th>
                              <th className="leger-col-description">Deskripsi</th>
                            </tr>
                          </thead>

                          <tbody>
                            {rows.length === 0 ? (
                              <tr>
                                <td colSpan={6} className="leger-empty-state">
                                  Data siswa tidak ditemukan
                                </td>
                              </tr>
                            ) : (
                              rows.map((rekap, rowIndex) => (
                                <tr key={rekap?.ysb_element_recap_id || rowIndex}>
                                  <td className="leger-col-number">
                                    <span className="leger-number-badge">{rowIndex + 1}</span>
                                  </td>
                                  <td className="leger-col-name">
                                    <button
                                      type="button"
                                      className="leger-student-button"
                                      onClick={() => handleOpenModal(element, rekap)}
                                    >
                                      {toTitleCase(rekap?.name_student)}
                                    </button>
                                  </td>
                                  <td className="leger-col-nisn leger-cell-center">
                                    {rekap?.nisn || "-"}
                                  </td>
                                  <td className="leger-col-score leger-cell-center">
                                    {rekap?.average ?? "-"}
                                  </td>
                                  <td className="leger-col-kkca leger-cell-center">
                                    {rekap?.kkca_description || "-"}
                                  </td>
                                  <td className="leger-col-description leger-cell-description">
                                    {rekap?.kkca_description_full || "-"}
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <ModalLeger
                      show={showModal}
                      onHide={() => setShowModal(false)}
                      data_leger={dataModal}
                      onSaved={handleModalSaved}
                    />
                  </Tab>
                );
              })}
            </Tabs>
          )}
        </div>
      </div>
    </>
  );
}
